import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Container } from '../Container';
export function FinalCta() {
  return <section className="py-24 bg-pts-red text-white text-center relative overflow-hidden" data-id="element-164">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#fff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-165"></div>

      <Container className="relative z-10" data-id="element-166">
        <h2 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-6" data-id="element-167">
          Ready to Outfit Your Team, League, or Organization?
        </h2>
        <p className="text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-168">
          Tell us your sport, group size, timeline, and what you need. Start
          your order, request free initial art mockups, or send us a quote to
          compare.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-169">
          <Link to="/get-started" className="bg-white text-pts-red hover:bg-gray-100 px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors w-full sm:w-auto shadow-lg" data-id="element-170">
            Start My Team Order
          </Link>
          <Link to="/mockup-request" className="bg-transparent border-2 border-white hover:bg-white hover:text-pts-red text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors w-full sm:w-auto" data-id="element-171">
            Start Art Mockups
          </Link>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-172">
          <a href="tel:8882188647" className="flex items-center text-white/90 hover:text-white font-bold text-lg transition-colors" data-id="element-173">
            <Phone className="h-5 w-5 mr-2" data-id="element-174" />
            Call 888.218.8647
          </a>
          <span className="hidden sm:block text-white/50" data-id="element-175">|</span>
          <Link to="/contact" className="text-white/90 hover:text-white font-bold text-sm transition-colors" data-id="element-176">
            Have a quote? Send it to us.
          </Link>
        </div>
      </Container>
    </section>;
}